import "./style.css"

import Carousel from "../swiper/Carousel"
import { useTranslation } from "react-i18next";

const Partners = () => {
    const { t } = useTranslation();
    return ( 
        <section id="Partners" className="partners-block">
            <div className="info">
                <h1> {t("companies.title")}</h1>   
                <p>
                    {t("companies.description")}
                </p>
            </div>
            
            <Carousel/>
        </section>
        
    );
}
 
export default Partners;